// extracted by mini-css-extract-plugin
module.exports = {"loadingWrap":"Loading_loadingWrap__oqBfb","loadingIcon":"Loading_loadingIcon__16B2W","loading":"Loading_loading__J8qno","loadingText":"Loading_loadingText__270gt"};